import { z } from 'zod';

import { createOffsetPaginationRequestQuerySchema } from './pagination';
import { PrimaryKeySchema, commaDelimitedList } from './utils';

export const UserEmailSchema = z.object({
  userEmailId: PrimaryKeySchema,
  userId: PrimaryKeySchema,
  email: z.string().email(),
  verifiedAt: z.coerce.date().nullable(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
});

export type UserEmail = z.infer<typeof UserEmailSchema>;

export const UserEmailsSchema = z.array(UserEmailSchema);

export type UserEmails = z.infer<typeof UserEmailsSchema>;

export const UserEmailFiltersSchema = z
  .object({
    userEmailIds: commaDelimitedList(PrimaryKeySchema.array()).optional(),
    userIds: commaDelimitedList(PrimaryKeySchema.array()).optional(),
    emails: commaDelimitedList(z.string().email().array()).optional(),
    isVerified: z.coerce.boolean().optional(),
  })
  .merge(
    createOffsetPaginationRequestQuerySchema(
      z.enum(['createdAt', 'verifiedAt']),
    ),
  );

export type UserEmailFilters = z.infer<typeof UserEmailFiltersSchema>;
